export default {
  type: "Feature",
  properties: {
    name: "Чойбалсан",
    location: [48.02977010442402, 114.08483921013607],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [112.69432067871094, 47.79378398661931],
        [112.60986328125, 47.929226038300406],
        [112.54119873046875, 48.0762438718672],
        [112.510986328125, 48.24113823848045],
        [112.5164794921875, 48.32156041109599],
        [112.54119873046875, 48.39456162202509],
        [112.5164794921875, 48.47838371535879],
        [112.48077392578124, 48.5147849720974],
        [112.2967529296875, 48.741700879765396],
        [112.23907470703124, 48.83941303819501],
        [112.23907470703124, 48.89000369970676],
        [112.28851318359375, 48.963089005540155],
        [112.291259765625, 48.9991410647952],
        [112.26654052734375, 49.034266715880854],
        [112.2198486328125, 49.081062364320736],
        [112.19375610351562, 49.14039340493346],
        [112.18551635742186, 49.2202880838794],
        [112.16629028320312, 49.30184481970431],
        [112.15393066406249, 49.32064646618636],
        [112.08114624023438, 49.359122687528746],
        [111.99600219726562, 49.392206057422044],
        [111.99600219726562, 49.392206057422044],
        [112.20062255859374, 49.44848596885694],
        [112.4615478515625, 49.52877389852215],
        [112.686767578125, 49.50737665842872],
        [112.950439453125, 49.58578744112238],
        [113.0438232421875, 49.60715036117516],
        [113.2196044921875, 49.84860975344834],
        [113.4613037109375, 49.930008124606914],
        [113.4722900390625, 49.97242235423708],
        [113.6370849609375, 49.993615462541136],
        [113.7579345703125, 50.078294547389426],
        [113.9117431640625, 50.12057809796008],
        [114.334716796875, 50.28933925329178],
        [114.53247070312499, 50.233151832472245],
        [114.7137451171875, 50.25071752130677],
        [114.90600585937499, 50.20854899229104],
        [115.08178710937499, 50.10648772767335],
        [115.24658203125, 49.983020075472226],
        [115.51574707031249, 49.905249238801304],
        [115.72998046875, 49.88755653624285],
        [116.07604980468749, 50.01832895590886],
        [116.2298583984375, 50.035973672195496],
        [116.630859375, 49.930008124606914],
        [116.707763671875, 49.83798245308484],
        [116.03485107421875, 48.87013489622034],
        [116.070556640625, 48.821332549646634],
        [115.78765869140625, 48.51842366030161],
        [115.80963134765625, 48.26308411537845],
        [115.521240234375, 48.15326053170714],
        [115.56655883789064, 47.924624978768314],
        [115.93597412109374, 47.68203210030427],
        [115.960693359375, 47.68757916850813],
        [116.11175537109376, 47.824220149350246],
        [116.24908447265624, 47.879512933970496],
        [116.444091796875, 47.837127072368524],
        [116.66931152343749, 47.88688085106898],
        [116.87255859374999, 47.89424772020999],
        [117.0703125, 47.82790816919327],
        [117.35595703124999, 47.64318610543658],
        [117.48779296875, 47.78363463526376],
        [117.8173828125, 48.026672195436014],
        [118.02612304687499, 48.00830020485928],
        [118.18542480468751, 48.04870994288686],
        [118.43261718749999, 47.98992166741417],
        [118.5479736328125, 47.99359789867388],
        [118.75671386718749, 47.76886840424207],
        [119.1302490234375, 47.66168780332917],
        [119.1412353515625, 47.54316365431733],
        [119.33898925781251, 47.48008846346322],
        [119.3280029296875, 47.428087261714275],
        [119.56970214843749, 47.253135632244216],
        [119.70703125, 47.178512264439085],
        [119.794921875, 47.02146130911727],
        [119.91577148437499, 46.897739085507],
        [119.92675781249999, 46.7210346612957],
        [119.67956542968749, 46.604167162931844],
        [119.42138671875, 46.638122462379656],
        [119.2181396484375, 46.649436163350245],
        [119.08630371093749, 46.66074749832071],
        [118.9874267578125, 46.758679967095574],
        [118.85559082031249, 46.7774927637683],
        [118.795166015625, 46.694667307773116],
        [118.63586425781249, 46.717268685073954],
        [118.56994628906249, 46.694667307773116],
        [118.39965820312499, 46.73233101286786],
        [118.2843017578125, 46.74738913515841],
        [118.037109375, 46.63057868059483],
        [117.850341796875, 46.53997127029103],
        [117.69653320312499, 46.51351558059737],
        [117.630615234375, 46.543749602738565],
        [117.60314941406249, 46.604167162931844],
        [117.42187500000001, 46.58529390583601],
        [117.4383544921875, 46.53619267489863],
        [117.3614501953125, 46.41892578708076],
        [117.37243652343749, 46.3583020562222],
        [117.0703125, 46.3583020562222],
        [116.817626953125, 46.3810438458062],
        [116.74621582031249, 46.32417161725694],
        [116.57592773437499, 46.2890709079757],
        [116.56562805175781, 46.25537204270996],
        [116.54228210449219, 46.23732751752229],
        [116.54159545898438, 46.23685258143992],
        [116.34246826171874, 46.511625395437925],
        [116.2847900390625, 46.5739667965278],
        [116.19415283203125, 46.592843997427394],
        [115.6805419921875, 46.581518465658014],
        [115.5596923828125, 46.543749602738565],
        [115.224609375, 46.54563867035857],
        [114.89501953124999, 46.49839225859763],
        [114.6807861328125, 46.70596917928676],
        [114.52285766601562, 46.76714653871027],
        [114.43634033203125, 46.825435656353896],
        [114.4171142578125, 46.89680070399431],
        [114.42398071289062, 47.00086080525212],
        [114.4720458984375, 47.12621341795227],
        [114.18090820312499, 47.253135632244216],
        [114.071044921875, 47.32393057095941],
        [113.9666748046875, 47.364873807434094],
        [113.8128662109375, 47.468949677672484],
        [113.675537109375, 47.5153457091302],
        [113.61785888671875, 47.51349065484327],
        [113.17565917968749, 47.55984733956309],
        [113.10150146484375, 47.58764167941513],
        [112.9669189453125, 47.613569753973955],
        [112.87353515625, 47.60616304386874],
        [112.74169921875, 47.57652571374621],
        [112.70050048828125, 47.724544549099676],
        [112.69432067871094, 47.79378398661931],
      ],
    ],
  },
};
